<template>
  <button
      type="button"
      class="
            btn
            btn-default
            p-2
            leading-none
            text-xs
            min-w-8
            h-8
            tiptap-button
        "
      :class="[editor.isActive(buttonName) ? 'btn-primary' : '', 'is-' + buttonName]"
      @click="toggle"
  >
  </button>
</template>

<script>
// https://tiptap.dev/api/nodes/heading
export default {
  props: ['buttonName', 'editor', 'commands'],
  methods: {

    toggle() {
      if (this.buttonName === 'italic') {
        this.editor.chain().focus().toggleItalic().run();
        return;
      }
      if (this.buttonName === 'bold') {
        this.editor.chain().focus().toggleBold().run();
        return;
      }

    },
  },
}
</script>



